<div class="row project-detail">
  <div class="f-1">
    <div class="row">
      <dx-drop-down-button
        [items]="filteredActions()"
        class="column"
        keyExpr="id"
        displayExpr="text"
        [text]="'BUTTONS.ACTIONS' | translate"
        icon="toolbox">
      </dx-drop-down-button>
      <dx-button
        class="column"
        [text]="isMapMaximized ? ('BUTTONS.MAP_CLOSE' | translate) : ('BUTTONS.MAP_OPEN' | translate)"
        icon="map"
        [width]="'100%'"
        (onClick)="toggleMapSize()"
        [disabled]="connectionString === ''"
        [title]="isMapMaximized ? ('BUTTONS.MAP_CLOSE' | translate) : ('BUTTONS.MAP_OPEN' | translate)">
      </dx-button>
    </div>

    @if (project()() !== undefined) {
      <div class="dx-field-break f-1">
        <div class="dx-field-label"></div>
        <div class="dx-field-value"></div>
      </div>
      <div class="row">
        <div class="dx-field-break f-1">
          <div class="dx-field-label">{{ 'PROJECT.ProcessingState' | translate }}:</div>
          <div class="dx-field-value">{{ 'PROCESSING_STATE.' + project()()!.ProcessingState | translate }}</div>
        </div>
        @if (showOmInfo()) {
          <div class="dx-field-break f-1 om-check">
            <div class="dx-field-label">{{ 'PROJECT.OM_CHECK' | translate }}:</div>
            <div class="dx-field-value errorMsg">{{ 'PROJECT.OM_CHECK_NEEDED' | translate }}</div>
          </div>
        } @else {
          <div class="dx-field-break f-1">
            <div class="dx-field-label"></div>
            <div class="dx-field-value"></div>
          </div>
        }

        <div class="dx-field-break f-1">
          <div class="dx-field-label">{{ 'PROJECT.Priority' | translate }}:</div>
          <div class="dx-field-value">{{ project()()!.Priority }}</div>
        </div>
      </div>

      <div class="dx-field-break f-1">
        <div class="dx-field-label"></div>
        <div class="dx-field-value"></div>
      </div>

      <div class="row">
        <div class="dx-field-break f-1">
          <div class="dx-field-label">{{ 'PROJECT.FromDateTime' | translate }}:</div>
          <div class="dx-field-value">{{ project()()!.FromDateTime | date: 'short' }}</div>
        </div>
        <div class="dx-field-break f-1">
          <div class="dx-field-label">{{ 'PROJECT.UntilDateTime' | translate }}:</div>
          <div class="dx-field-value">{{ project()()!.UntilDateTime | date: 'short' }}</div>
        </div>
        <div class="dx-field-break f-1">
          <div class="dx-field-label">{{ 'PROJECT.RampNeeded' | translate }}:</div>
          <dx-check-box [readOnly]="true" [value]="project()()!.RampNeeded"></dx-check-box>
        </div>
      </div>

      <div class="dx-field-break f-1">
        <div class="dx-field-label"></div>
        <div class="dx-field-value"></div>
      </div>

      <div class="row">
        <div class="dx-field-break f-1">
          <div class="dx-field-label">{{ 'PROJECT.Driver' | translate }}:</div>
          <div class="dx-field-value">{{ project()()!.Driver }}</div>
        </div>
        <div class="dx-field-break f-1">
          <div class="dx-field-label">{{ 'PROJECT.Vehicle' | translate }}:</div>
          <div class="dx-field-value">{{ project()()!.Vehicle }}</div>
        </div>
        <div class="dx-field-break f-1">
          <div class="dx-field-label">{{ 'PROJECT.TunnelCode' | translate }}:</div>
          <dx-check-box [readOnly]="true" [value]="project()()!.TunnelCode > 0"></dx-check-box>
        </div>
      </div>
    }
  </div>
  <div class="map-panel">
    @if (isMapMaximized) {
      <div class="map-container map-maximized">
        <dx-map
          #map
          [zoom]="ZOOM_DEFAULT"
          [center]="NICLEN_HOME"
          width="100%"
          [provider]="'azure'"
          [apiKey]="connectionString"
          [type]="'roadmap'"
          [controls]="false"
          [markers]="markers"
          [routes]="routes"
          [autoAdjust]="false"
          (onReady)="onMapReady()">
        </dx-map>
        <div class="toggle-buttons">
          <dx-button
            class="toggle-button"
            (onClick)="resetMapZoom()"
            [hint]="'MAP.CENTER' | translate"
            icon="fullscreen"></dx-button>
          <dx-button
            class="toggle-button"
            (onClick)="toggleHomeRoute()"
            [disabled]="mapUpdate.busy()"
            [class.green-bg]="homeRoute"
            [class.red-bg]="!homeRoute"
            [hint]="homeRoute ? ('MAP.WITH_HOME' | translate) : ('MAP.WITHOUT_HOME' | translate)"
            icon="home"></dx-button>
          <div class="map-info">
            @if (routeDistances.length > 0) {
              <div class="map-info-content">
                <span class="info-entry">
                  <span>{{ 'ROUTES.LIST.HOME_FIRST_STATION' | translate }}</span> <b>{{ routeDistances[0] }}km</b>
                </span>
                <span class="info-entry">
                  <span>{{ 'ROUTES.LIST.HOME_LAST_STATION' | translate }}</span> <b>{{ routeDistances[1] }}km</b>
                </span>
                <span class="info-entry">
                  <span>{{ 'ROUTES.LIST.LAST_HOME' | translate }}</span> <b>{{ routeDistances[2] }}km</b>
                </span>
                <span class="info-entry">
                  <span>{{ 'ROUTES.LIST.WHOLE_TOUR' | translate }}</span> <b>{{ routeDistances[3] }}km</b>
                </span>
              </div>
            }
          </div>
          <dx-button
            icon="close"
            stylingMode="text"
            class="toggle-button"
            [hint]="'MAP.CLOSE' | translate"
            (onClick)="toggleMapSize()">
          </dx-button>
        </div>
      </div>
    }
  </div>
</div>
